import { SvgSymbol } from '../symbol-factory';

export const ChevronThinDown: SvgSymbol = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.8746 6.12586C14.0418 6.29302 14.0418 6.56463 13.8746 6.73178L9.30323 11.3032C9.13554 11.4709 8.86446 11.4709 8.69677 11.3032L4.12537 6.73178C3.95821 6.56462 3.95821 6.29302 4.12537 6.12586C4.29252 5.95817 4.56413 5.95817 4.73129 6.12586L9.00001 10.394L13.2687 6.12586C13.4359 5.95817 13.7075 5.95817 13.8746 6.12586Z"
    />
  </svg>
);
